/**
 * Created by cl-macmini-34 on 04/09/17.
 */
(function () {

    App.factory('mixPanelApi',MixPanelApi);
    function MixPanelApi(){
        var serviceObj = {};
        serviceObj.register = Register;
        serviceObj.unRegister = UnRegister;
        serviceObj.track = Track;
        serviceObj.event = Event;

        function Register(data){
            mixpanel.register(data);
        }
        function UnRegister(){
            mixpanel.unregister('userType');
            mixpanel.unregister('User Type');
            mixpanel.unregister('User Name');
            mixpanel.unregister('User Id');
            mixpanel.unregister('User EmailId');
            mixpanel.unregister('User Profile Completed');
            mixpanel.unregister('User Profile Approved');
        }
        function Track(event,data){
            mixpanel.track(event,data);
        }
        function Event(){
            var obj = {
                'LOG_IN':'Log In',
                'SIGN_UP':'Sign Up',
                'JOB_WORKFLOW':'Job Workflow'
            };
            return obj;
        }

        return serviceObj;
    }

    // mixpanel token assign
    App.run(function () {mixpanel.init('91866e0022a7ff2d018341ac4195e025');});


})();